import Swiper from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';

const INIT_KEY = 'topPageOpeningSliderInitialized';

export default function TopPageOpeningSlider() {
  const slider = document.querySelector('.js-top-page-opening-slider');

  if (!slider || slider.dataset[INIT_KEY] === 'true') {
    return;
  }

  slider.dataset[INIT_KEY] = 'true';

  const slideCount = slider.querySelectorAll('.swiper-slide').length;
  const prevButton = slider.querySelector('[data-js="top-page-opening-prev"]');
  const nextButton = slider.querySelector('[data-js="top-page-opening-next"]');
  const pagination = slider.querySelector('[data-js="top-page-opening-pagination"]');

  new Swiper(slider, {
    modules: [Autoplay, EffectFade, Navigation, Pagination],
    slidesPerView: 1,
    speed: 900,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: slideCount > 1,
    watchOverflow: true,
    allowTouchMove: slideCount > 1,
    autoplay: slideCount > 1 ? {
      delay: 3200,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    } : false,
    navigation: {
      prevEl: prevButton,
      nextEl: nextButton,
    },
    pagination: {
      el: pagination,
      clickable: true,
      bulletClass: 'top-page-opening__pagination-dot',
      bulletActiveClass: 'is-active',
    },
  });
}
